export default {
  request_promotion: "Request Paid Promotion",
  products: "Products",
  categories: "Categories",

  search_product: "Search Product",
  search_product_placeholder: "Search product...",
  search_category: "Search Category",
  search_category_placeholder: "Search category...",

  select_all: "Select All",
  remove_all: "Remove All",
  selected_products: "Selected Products",

  title: "Title",
  headline: "Headline",
  description: "Description",

  offer_type: "Offer Type",
  select_offer_type: "Select Offer Type",
  percentage: "Percentage (%)",
  flat_amount: "Flat Amount",

  offer_value: "Offer Value",
  bid_amount: "Bid Amount",
  banner_image: "Banner Image (Optional)",

  select_cities: "Select Cities",

  start_date: "Start Date",
  end_date: "End Date",

  cancel: "Cancel",
  submit_request: "Submit Request",

  select_product_error: "Select at least one product",
  select_offer_error: "Select offer type",
  enter_value_error: "Enter offer value",
  promotion_success: "Promotion Request Sent to Admin",
  clear_form: "Clear this form?",
  choose_file: "Choose File",
no_file_selected: "No file selected",
file_selected: "File selected",
percentage: "Percentage",
flat_amount: "Flat Amount",
select_offer_type: "Select offer type",
};